import { useRecoilValue } from 'recoil';

import { tokenState } from '@/recoil/atoms/common/auth';
import { communityUserService } from '@/services/community';

import useSetAuthOnScreenFocus from './auth/useSetAuthOnScreenFocus';
import { useGetCommunityUserQuery } from './community/mobile/community.gql.impl';

const useGetCommunityUser = () => {
  useSetAuthOnScreenFocus();
  const token = useRecoilValue(tokenState);

  // 유저 정보 가져오기
  const { data: userProfile } = useGetCommunityUserQuery(
    {},
    {
      enabled: !!token,
      select: (data) => communityUserService(data),
    },
  );

  return {
    userProfile,
  };
};

export default useGetCommunityUser;
